import { Routes, Route, Navigate } from 'react-router-dom'
import { FirebaseClientProvider } from '@/firebase'
import { Toaster } from '@/components/ui/toaster'
import { AppShell } from '@/components/layout/AppShell'

// Import pages - we'll update these imports as we restructure
import HomePage from '@/app/(app)/page'
import LoginPage from '@/app/(auth)/login/page'
import ItineraryListPage from '@/app/(app)/itinerary/page'
import ItineraryCreatePage from '@/app/(app)/itinerary/create/page'
import ItineraryDiscoverPage from '@/app/(app)/itinerary/discover/page'
import ItineraryDiscoverSlugPage from '@/app/(app)/itinerary/discover/[slug]/page'
import ItineraryGeneratedPage from '@/app/(app)/itinerary/generated/page'
import ItineraryDetailPage from '@/app/(app)/itinerary/[id]/page'
import LocationsPage from '@/app/(app)/locations/page'
import LocationDetailPage from '@/app/(app)/locations/[slug]/page'
import MapPage from '@/app/(app)/map/page'
import ProfilePage from '@/app/(app)/profile/page'
import AccommodationSearchPage from '@/app/(app)/accommodation/search/page'
import CarRentalSearchPage from '@/app/(app)/car-rental/search/page'

// Layout wrapper for authenticated app routes
function AppLayout() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/itinerary" element={<ItineraryListPage />} />
        <Route path="/itinerary/create" element={<ItineraryCreatePage />} />
        <Route path="/itinerary/discover" element={<ItineraryDiscoverPage />} />
        <Route path="/itinerary/discover/:slug" element={<ItineraryDiscoverSlugPage />} />
        <Route path="/itinerary/generated" element={<ItineraryGeneratedPage />} />
        <Route path="/itinerary/:id" element={<ItineraryDetailPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/locations/:slug" element={<LocationDetailPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/accommodation/search" element={<AccommodationSearchPage />} />
        <Route path="/car-rental/search" element={<CarRentalSearchPage />} />
      </Routes>
    </AppShell>
  )
}

function App() {
  return (
    <FirebaseClientProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<AppLayout />} />
      </Routes>
      <Toaster />
    </FirebaseClientProvider>
  )
}

export default App
